/**
 * @overview 角色菜单权限
 * @author 3173
 * @date 2019-1
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '../../../../tool'
import 'antd/dist/antd.css';
import '../../../../styles/containers/auth/menu/index.less';
import { Row, Col } from 'antd';
// import { deepReplaceKey } from "../../../../tool/frameworks/src/components/wizTableList/utils";
let { WizContainer, WizReduxTemplatem, modelUtils } = framework_tool;
let { WizCard, WizLayout, WizIcon, WizMenu, WizTree, WizTable, WizButton, WizCheckbox, WizModal, WizAlert } = component_tool;
const SubMenu = WizMenu.SubMenu;
import { Spin } from 'antd'
let { Session,checkStrLength, deepReplaceKey } = utils_tool;
import cx from 'classnames';
import { element } from 'prop-types';
class RoleManager extends WizContainer {

  componentName = 'RoleManager';

  constructor(props) {
    super(props);
    this.state = {
      selectModal: false,
      menuName: props.history.location && props.history.location.record ? props.history.location.record.name : null,
      menuId: props.history.location && props.history.location.record ? props.history.location.record.id : null,
      menuElements: [],//菜单对应可选元素
      powerData: [],
      selectedKeys: { checked: [], halfChecked: [] },
      userCount: 0,//用户数量
    }
    this.sumbit = true; //防止多次提交点击
    this.roleId;
    this.roleName;
    this.expandedKeys = [];
    this.menuElements = [];
    this.selectMenuId;
  }


  _componentDidMount() {
    const { history } = this.props;
    if (history.location && history.location.record) {
      Session.set('roleRecord', history.location.record);
    }
    this.doActions([
      {
        path: 'menu/getMenus',
        payload: {
          key: 'getMenus',
          apiParams: {
            disabled: 0
          }
        },
        autoInit: true,
      },
    ])
    if (Session.get('roleRecord')) {
      let record = Session.get('roleRecord');
      this.roleId = record.id;
      this.roleName = record.name;
      this.getMenuPower(Session.get('roleRecord').id);
    }

  }

  /**获取角色已关联的菜单、元素 */
  getMenuPower(roleId) {
    this.doAction({
      path: 'roleMenuElements/getMenuPowerByRoleId',
      payload: {
        key: 'getMenuPower',
        apiParams: { roleId: roleId }
      },
      autoInit: true,
    })
  }

  /**获取菜单对应的元素 */
  getElements(menuId) {
    this.doAction({
      path: 'elements/getElementsByMenuId',
      payload: {
        key: 'getElementsByMenuId',
        apiParams: { menuId: menuId }
      },
      autoInit: true,
    })
  }

  /**保存角色菜单权限 */
  save() {
    if (this.sumbit) {
      this.sumbit = false;
      const list = this.arrange();
      this.doAction({
        path: 'roleMenuElements/batchSave',
        payload: {
          key: 'batchSave',
          apiParams: {
            roleId: this.roleId,
            roleMenuElements: list
          }
        },
        autoInit: true,
      })
    }
  }


  propsAndStateOnChange = {
    seachElements: this._seachElementsOver.bind(this),
    batchSave: this._saveOver.bind(this),
    menuPower: this._menuRightOfUseTransform.bind(this),
    treeMenus: this.getTreeMenusOver.bind(this)
  }

  /**设置当前菜单可以选择的元素 */
  _seachElementsOver(nextProps, nextState) {
    const { powerData } = this.state;
    //Checkbox.Group 需要 label显示名 value值
    let menuElements = [];
    nextProps.seachElements && nextProps.seachElements.forEach(
      element => {
        menuElements.push({ label: element.name, value: element.id })
      }
    )
    let neoPowerData = Object.assign([], powerData);
    for (let i = 0; i < powerData.length; i++) {
      if (powerData[i].menuId === this.state.menuId) {
        neoPowerData[i]['menuElements'] = menuElements;
        break;
      }
    }
    nextState.powerData = neoPowerData;
    this.menuElements = menuElements;
    return true;
  }

  _saveOver(nextProps, nextState) {
    this.sumbit = true;
    if (nextProps.batchSave.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace','/auth/roleList');
    } else {
      wizNotice.error('保存失败：' + nextProps.batchSave.msg);
    }
    return true;
  }

  _menuRightOfUseTransform(nextProps, nextState) {
    let neoPowerData = [];
    let checked = [];
    nextProps.menuPower && nextProps.menuPower instanceof Array && nextProps.menuPower.forEach(data => {
      let menuElements = []
      data.menuElements && data.menuElements.forEach(element => {
        menuElements.push({ label: element.name, value: element.id })
      })
      neoPowerData.push({
        menuId: data.menuId,
        menuName: data.menuName, //菜单名称
        menuNumber: data.menuNumber, //菜单编码
        type: data.type,//菜单类型
        roleName: this.roleName, //角色名称
        roleId: this.roleId, //角色id
        elementIds: data.elementIds, //已选元素id
        menuElements: menuElements
      })
      checked.push(data.menuId);
    })
    nextState.powerData = neoPowerData;
    let selectedKeys = { checked: [], halfChecked: [] }
    selectedKeys.checked = checked;
    nextState.selectedKeys = selectedKeys;
    return true;
  }

  getTreeMenusOver(nextProps, nextState) {
    if (nextProps.treeMenus && nextProps.treeMenus.length > 0) {
      let len = 10
        let f = (v) => {
          v && v.forEach(val => {
            val['title'] = checkStrLength(val['title'], len);
            if (val['children'] && val['children'].length > 0) {
              f(val['children'])
            }
          });
        }
        f(nextProps.treeMenus)
      }
  }



  /**把state里的数据处理成对应的关联数据结构给后台保存 */
  arrange() {
    let result = [];
    this.state.powerData.forEach(data => {
      //先增加角色与菜单关联
      result.push({
        menuId: data.menuId,
        roleId: data.roleId,
      })
      //增加角色与菜单的元素关联
      data.elementIds.forEach(elementId => {
        if (elementId != 0) {
          result.push({
            menuId: data.menuId,
            roleId: data.roleId,
            elementsId: elementId,
          })
        }
      })
    })
    return result;
  }



  /**
   * 树结构节点选择
   * @param {*} selectedKeys
   * @param {*} param1
   */
  nodeOnSelect(selectedKeys, { selected, selectedNodes, node, event }) {
    let neoPowerData = Object.assign([], this.state.powerData);
    //移除取消的数据
    if (selectedKeys.checked.length <= this.state.powerData.length) {
      this.deleteRole(node.props.id)
      this.setState({
        selectedKeys: selectedKeys,
      })
    } else {
      let data = {
        menuId: node.props.id,
        menuName: node.props.name, //菜单名称
        roleName: this.roleName, //角色名称
        roleId: this.roleId, //角色id
        elementIds: [], //已选元素id
        menuElements: [],//菜单对应元素
        key: node.props.id,
        menuNumber: node.props.number,
        type:node.props.type
      }

      if(node.props.id == this.state.menuId){
        data.menuElements = this.menuElements;
      }

      neoPowerData.push(data);
      this.setState({
        selectedKeys: selectedKeys,
        powerData: neoPowerData,
        menuId: node.props.id
      })

      if (node.props.type !== 0 && node.props.id != this.state.menuId) {
        this.getElements(node.props.id);
      }

    }

  }

  /**移除菜单角色 */
  deleteRole(menuId) {
    const { powerData } = this.state;
    let checked = [];
    let neoPowerData = Object.assign([], this.state.powerData);
    let selectedKeys = Object.assign({}, this.state.selectedKeys);
    for (let i = 0; i < powerData.length; i++) {
      if (powerData[i].menuId === menuId) {
        neoPowerData.splice(i, 1);
      }else{
        checked.push(powerData[i].menuId);
      }
    }
    selectedKeys.checked = checked;
    this.setState({ powerData: neoPowerData,selectedKeys:selectedKeys });
  }

  /**修改 */
  onChange(checkedValues, record) {
    const { powerData } = this.state;
    let neoPowerData = Object.assign([], this.state.powerData);
    for (let i = 0; i < powerData.length; i++) {
      if (powerData[i].menuId === record.menuId) {
        neoPowerData[i].elementIds = checkedValues;
        break;
      }
    }
    this.setState({ powerData: neoPowerData });
  }



  _render() {
    const { history } = this.props;
    const columns = [
      {
        title: '菜单',
        dataIndex: 'menuName',
        key: 'menuName',
        width:100
      },
      {
        title: '菜单编号',
        dataIndex: 'menuNumber',
        key: 'menuNumber',
        width:100
      },
      {
        title: '元素权限',
        dataIndex: 'elements',
        key: 'elements',
        render: (text, record) => (
          this.state.menuType == 0 || record.type == 0?null:
          <WizCheckbox.Group key={record.menuId} options={record.menuElements} defaultValue={record.elementIds} onChange={(checkedValues) => this.onChange(checkedValues, record)} />
        ),
      },
      {
        title: '操作',
        key: 'action',
        render: (text, record) => (
          <WizButton type="link" className="button" onClick={this.deleteRole.bind(this, record.menuId)}>删除</WizButton>
        ),
      },
    ];
    let expandedKeys = this.expandedKeys;
    return (
      <Spin tip={'加载中'} spinning={this.props.menuLoading || this.props.elementsLoading || this.props.roleMenuElementsLoading}>
        <WizCard className='menu-item'>
          <WizLayout key={this.componentName + '@Layout'}>
            <WizLayout.Header>
              <Row className="header-row">
                <span className="header-icon-font">当前角色：</span> <span className="header-role-font">{this.roleName}</span>
              </Row>
              <Row>
                <Col span={2} >
                  <WizIcon type="question-circle" />
                  <span className="header-icon-font">设置说明</span>
                </Col>
                <Col span={22} push={1}>
                  <div className="header-font">1、请在需要分配给该角色的导航菜单级权限节点上勾选菜单勾。</div>
                  <div className="header-font">2、菜单勾选后,表示该角色下的用户可以在导航中看到此菜单。</div>
                  <div className="header-deepen-font">3、修改后的权限需要用户重新登录才会生效。</div>
                </Col>
              </Row>

            </WizLayout.Header>


          </WizLayout>

          <WizLayout className="sider-layout">
            <WizLayout.Sider width={236} collapsedWidth={236} trigger={null} breakpoint="lg" collapsible={false} className="sider">
              <div className="sider-header"><WizIcon type="unordered-list" /> <span className="sider-header-font"> 菜单</span></div>
              <WizTree style={{ maxWidth: 234 ,overflow:'auto'}} onCheck={this.nodeOnSelect.bind(this)} checkable={true} checkStrictly={true} defaultExpandAll={true} defaultExpandParent={true} defaultExpandParent={true} autoExpandParent={true}  checkedKeys={this.state.selectedKeys} treeData={deepReplaceKey(this.props.treeMenus ? this.props.treeMenus : [], [{ key: "parentId", value: "key" }])} />
            </WizLayout.Sider>
            <WizLayout.Content className="content" >
              <div className="content-div">
                <WizTable columns={columns} dataSource={this.state.powerData} />

                <div className="sumbit-btns">
                  <WizButton type="primary" className="button" onClick={this.save.bind(this)}>保存</WizButton>
                  <WizButton className="button" onClick={() =>this.jumpPage('replace','/auth/roleList')}>取消</WizButton>
                </div>
              </div>
            </WizLayout.Content>
          </WizLayout>
        </WizCard>
      </Spin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { menu, elements, roleMenuElements, roleUser } = state;
  const treeMenus = modelUtils.getModelEntity(menu, "getMenus");
  const seachElements = modelUtils.getModelEntity(elements, "getElementsByMenuId");
  const batchSave = modelUtils.getModelEntity(roleMenuElements, "batchSave");
  const getMenuPower = modelUtils.getModelEntity(roleMenuElements, "getMenuPower");
  const getPersonIdsByRoleIds = modelUtils.getModelEntity(roleUser, "getPersonIdsByRoleIds");
  const load = modelUtils.getLoadingState(state, ['elements', 'menu', 'roleMenuElements']);
  return {
    treeMenus: treeMenus.data,
    seachElements: seachElements.data,
    batchSave: batchSave,
    menuPower: getMenuPower.data,
    personIds: getPersonIdsByRoleIds.data,
    ...load
  }
};

export default connect(mapStateToProps)(RoleManager);
